export const ENVIRONMENT_FILE = "/hdri/potsdamer_platz_1k.jpg";

export const BREAKPOINTS = {
	mobile: 768,
	tablet: 1024,
	desktop: 1440,
};
